import { List, Map } from 'immutable';
import {
  functions as webdriverCommandFunctions,
  types as webdriverCommandTypes,
} from '@saucelabs/sl-module-webdriver-commands';
import { types as espressoCommandTypes } from '@saucelabs/sl-module-espresso-commands';
import {
  types as jobTypes,
  records as jobRecords,
} from '@saucelabs/sl-module-jobs';
import {
  types as buildsTypes,
  records as buildsRecords,
} from '@saucelabs/sl-module-builds';

import * as constants from './constants';
import * as types from './types';


const initialState = Map({
  assets: {},
  assetListFetched: false,
  build: new buildsRecords.BuildRecord(),
  commands: List(),
  commandsLoadStatus: constants.COMMANDS_FETCH_LOADING,
  job: new jobRecords.JobRecord(),
  selectorsMapping: {},
  scrollTimeStamp: 0,
});

const mergeAssets = ({ state, payload }) => {
  const assets = state.get('assets');
  const withValues = Object.entries(payload).reduce((acc, [key, value]) => {
    if ([null, undefined].includes(value)) {
      return acc;
    }

    return { ...acc, [key]: value };
  }, {});
  return state.set('assets', { ...assets, ...withValues });
};

const jobReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case jobTypes.JOB_GET.SUCCESS:
      return state.set('job', new jobRecords.JobRecord(payload));
    case jobTypes.UP_JOB_GET.SUCCESS:
      return state.set('job', new jobRecords.RdcJobRecord(payload));
    case espressoCommandTypes.PARSE_ESPRESSO_JOB:
      return state
        .set('commands', payload)
        .set('commandsLoadStatus', constants.COMMANDS_FETCH_SUCCESS);
    case webdriverCommandTypes.PARSE_APPIUM_JOB:
    case webdriverCommandTypes.PARSE_SELENIUM_JOB: {
      const withoutVisuals = webdriverCommandFunctions.updateVisualCommands(payload);
      return state
        .set('selectorsMapping', webdriverCommandFunctions.buildSeleniumSelectorsMap(withoutVisuals))
        .set('commands', withoutVisuals)
        .set('commandsLoadStatus', constants.COMMANDS_FETCH_SUCCESS);
    }
    case buildsTypes.BUILD_GET_BY_NAME.SUCCESS:
      return state.set('build', new buildsRecords.BuildRecord(payload));
    case jobTypes.CHANGE_VISIBILITY.SUCCESS:
      return state.set('job', new jobRecords.JobRecord({
        ...state.get('job').toJS(),
        ...payload,
      }));
    case jobTypes.ASSET_LIST_GET.SUCCESS: {
      return mergeAssets({ state, payload }).set('assetListFetched', true);
    }
    case jobTypes.SET_ASSET_LIST: {
      return mergeAssets({ state, payload });
    }
    case types.COMMAND_ICON_SELECT: {
      const commands = state.get('commands');
      const commandIndex = commands.findIndex((command) => command.id === payload.id);
      const updatedCommands = commands.update(commandIndex, (command) => (
        command.set('collapsed', !command.get('collapsed'))
      ));
      return state.set('commands', updatedCommands);
    }
    case types.UPDATE_ACTIVE_COMMAND: {
      const { collapseCurrent, newActiveIndex, oldActiveIndex } = payload;
      return state.withMutations((newState) => {
        if (Number.isFinite(oldActiveIndex) && oldActiveIndex >= 0) {
          newState.setIn(['commands', oldActiveIndex, 'active'], false);
        }
        newState.setIn(['commands', newActiveIndex, 'active'], true);
        if (collapseCurrent) {
          newState.setIn(['commands', oldActiveIndex, 'collapsed'], true);
        }
      });
    }
    case types.UPDATE_SCROLL_TIMESTAMP:
      return state.set('scrollTimeStamp', payload);
    case types.ASSETS_EXPIRED:
      return state.set('commandsLoadStatus', constants.COMMANDS_FETCH_FAILURE);
    case jobTypes.ASSET_GET.FAILURE: {
      const { config } = payload;
      if (config && config.url && /\/log\.json$/.test(config.url)) {
        return state.set('commandsLoadStatus', constants.COMMANDS_FETCH_FAILURE);
      }
      return state;
    }
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default jobReducer;
export { initialState };
